import * as projectApi from '@/api/projectApi.js'
import * as dashboardApi from '@/api/dashboardApi.js'
import { useUserStore } from '@/stores/userStore'

export default {
    namespaced: true,
    state() {
        return {
            projectListDat: [],
            projectListUsers: [],
            projectInfo: null
        }
    },
    getters: {
        getList(state) {
            return state.projectListDat
        },
        getListUsers(state) {
            return state.projectListUsers
        },
        getInfo(state) {
            return state.projectInfo
        }
    },
    mutations: {
        setList(state, listData) {
            state.projectListDat = JSON.parse(listData)
        },
        setListUsers(state, listData) {
            state.projectListUsers = JSON.parse(listData)
        },        
        setInfo(state, listData) {
            state.projectInfo = JSON.parse(listData)
        },
        clearInfo(state) {
            state.projectInfo = null
        },
    },
    actions: {
        async list({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.listProject(token, data)

            if (dataResp) {
                commit('setList', JSON.stringify(dataResp))
            }
        },
        async listUsers({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.listUsers(token, id)

            if (dataResp) {
                commit('setListUsers', JSON.stringify(dataResp))
            }

            return dataResp
        },
        async info({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp  = await dashboardApi.projectInfo(token, id)

            if (dataResp) {
                commit('setInfo', JSON.stringify(dataResp))
            }

            return dataResp
        },
        async delete({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.delProject(token, id)

            if (dataResp) {
                commit('clearInfo')
            }
        },
        async saveProject({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.updateProject(token, data)

            if (dataResp) {
                commit('clearInfo')
            }
            return dataResp
        },
        async inviteCode({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.inviteCode(token, data)
            return dataResp
        }, 
        async listControllers({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.listController(token, data)
            return dataResp
        },        
        async assignController({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.assignController(token, data)
        },
        async detachController({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.detachController(token, data)
        },
        async listManagers({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.listManager(token, data)
            return dataResp
        },        
        async assignManager({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.assignManager(token, data)
        },
        async detachManager({commit}, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await projectApi.detachManager(token, data)
        },                                 
    }
}